import React from 'react';
import { IconSuccess } from '@americanexpress/dls-react';

const SuccessPage = () => (
  <div className="margin-responsive fade-in">
    <h1>Submission Confirmed <IconSuccess /></h1>    
    <div className="new-line" />
    <div className="new-line" />
    <h4>
      Your request to become an American Express Supplier has been successfully submitted!
    </h4>
    <h4>We will contact you with any questions.</h4>
    <div className="new-line"/>
    <h4>
      Please note that we may check in with you periodically to ensure we keep this information up to date.
    </h4>
    <div className="new-line" />
    <h4>
      <a href="/vendorintake">Click here</a> to create a new vendor.
    </h4>
  </div>
);

export default SuccessPage;
